// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"293":"component---src-pages-index-js","869":"styles"}[chunkId] + "-" + {"293":"890e9e5bface1fdca397","869":"290526e24acfc54e4aad"}[chunkId] + ".js";
};